import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { SortableList } from '../../../SortableList';
import { Typography } from '../../../Typography';
import styles from './ColumnsPanel.module.scss';
import { ColumnsPanelRow } from './ColumnsPanelRow';
export function ColumnsPanel(param) {
    let { title, frozenLabel, entries, bi, onToggleVisibility, onReorder, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const mainEntry = entries.find((entry)=>entry.isMain);
    const reorderableEntries = entries.filter((entry)=>!entry.isMain);
    const panelRow = (entry)=>/*#__PURE__*/ _jsx(ColumnsPanelRow, {
            entry: entry,
            frozenLabel: frozenLabel,
            toggleBi: bi.toggleVisibility,
            onToggleVisibility: onToggleVisibility,
            testId: testId
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.panel,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                className: styles.title,
                testId: testIds.title(),
                children: title
            }),
            mainEntry != null && /*#__PURE__*/ _jsx("div", {
                className: styles.mainEntry,
                children: panelRow(mainEntry)
            }),
            /*#__PURE__*/ _jsx(SortableList, {
                bi: bi.reorder,
                items: reorderableEntries,
                testId: testId,
                onReorder: (reordered)=>onReorder === null || onReorder === void 0 ? void 0 : onReorder([
                        ...mainEntry != null ? [
                            mainEntry.id
                        ] : [],
                        ...reordered.map((entry)=>entry.id)
                    ]),
                renderItem: panelRow
            })
        ]
    });
}
